'use client';

import clsx from 'clsx';

const COLORS = [
  '#1a5276', '#2980b9', '#27ae60', '#e67e22', '#8e44ad',
  '#c0392b', '#16a085', '#d35400', '#2c3e50', '#f39c12',
  '#e74c3c', '#3498db', '#9b59b6', '#1abc9c', '#e91e63',
];

function getColorFromName(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return COLORS[Math.abs(hash) % COLORS.length];
}

function getInitials(name: string): string {
  const trimmedName = name.trim();
  if (!trimmedName) return '?';
  const parts = trimmedName.split(/\s+/);
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

interface UserAvatarProps {
  name?: string | null;
  avatar?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeMap = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-12 w-12 text-sm',
  lg: 'h-16 w-16 text-lg',
  xl: 'h-24 w-24 text-2xl',
};

export function UserAvatar({ name, avatar, size = 'md', className }: UserAvatarProps) {
  const displayName = name?.trim() ?? '';

  if (avatar) {
    return (
      <img
        src={avatar}
        alt={displayName || 'User avatar'}
        className={clsx('rounded-full object-cover', sizeMap[size], className)}
      />
    );
  }

  const color = getColorFromName(displayName);
  const initials = getInitials(displayName);

  return (
    <div
      className={clsx(
        'flex items-center justify-center rounded-full font-semibold text-white',
        sizeMap[size],
        className,
      )}
      style={{ backgroundColor: color }}
    >
      {initials}
    </div>
  );
}
